"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationUnreadBadge = NotificationUnreadBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var text_component_1 = require("../ui/text-component");
function NotificationUnreadBadge() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "shrink-0 rounded-full bg-primary-green px-2 py-0.5", "aria-label": "Unread", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "bold", uppercase: true, color: "white", className: "tracking-wide", label: "New" }) }));
}
